
import TableList from "@components/templates/tablelist";
import { HttpGetBaseCostList, HttpDeleteBaseCostOne } from "@/service/fedex";
import { mapGetters } from "vuex";
import comImport from './comImport'
// import mixin from "../mixin";
export default {
    mixins: [TableList],
    components: {
        comImport
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetBaseCostList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "edit":
                    this.$router.push({
                        name: 'fedexUpdateBasecost',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    var url = this.$router.resolve({
                        name: "fedexUpdateBasecost",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDeleteBaseCostOne
                    };
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data',{defaultValue:'导入数据'}),
                        width: 460,
                        showFooter: false,
                        component: "comImport",
                    }
                    break
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/fedexBaseCost/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [{
                label: this.$t('fbb.alloment.query_detail',{defaultValue:'查看详情'}),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit',{defaultValue:'编辑'}),
                show: true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete',{defaultValue:'删除'}),
                show: true,
                params: id,
                operate: 'delete'
            }]
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getCarrierServiceList']),
        ToolsData() {
            return [
                {
                    name: this.$t('fbb.alloment.muti_import',{defaultValue:'批量导入'}),
                    operate: "import",
                    theme: "primary",
                }, {
                    name: this.$t('fbb.alloment.muti_export',{defaultValue:'批量导出'}),
                    operate: "export",
                    more: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                    tag: 'vInput',
                    key: 'EQ_account',
                    show: true,
                },
                {
                    label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    tag: 'vSelect',
                    key: 'EQ_carrierServiceCode',
                    show: true,
                    props: {
                        filterable: true
                    },
                    options: this.getCarrierServiceList.map(item=>{
                        return {
                            value: item.attach.carrierServiceCode,
                            label:item.label
                        }
                    }),
                },
                {
                    label: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                    tag: 'vInput',
                    key: 'EQ_zoneCode',
                },
                {
                    label: this.$t('global.common.weight',{defaultValue:'重量'}),
                    tag: 'vInput',
                    key: 'EQ_weight',
                },
            ]
        },
        columns() {
            return [{
                title: this.$t('global.common.actions',{defaultValue:'操作'}),
                maxWidth: 90,
                render: this.getOperateNodes
            }, {
                title: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                key: 'account',
            },
            {
                title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                key:'carrierServiceCode'
                // render: (h, { row }) => {
                //     return <div>{row.carrierCode} ({row.carrierServiceCode})</div>
                // }
            },
            {
                title: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                key: 'zoneCode',
            },
            {
                title: this.$t('global.common.weight',{defaultValue:'重量'})+'（lbs）',
                key: 'weight',
            },
            {
                title: this.$t('global.common.weight',{defaultValue:'费用'})+'（usd）',
                key: 'cost',
            },
            {
                title: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
                key: 'createdAt',
                sortable: true
            },
            ];
        },

    },

};
